var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnDestroy, QueryList, TemplateRef } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ContentsHelper } from "../../../helpers/contents.helper";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { DomSanitizer } from '@angular/platform-browser';
import { DetailService } from "../../../services/details/detail.service";
import { ENVIRONMENT } from "../../../../environments/environment";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { HelperService } from '../../../services/helperService';
import { SharedDataService } from '../../../services/shared/shared-data.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataTableDirective } from "angular-datatables";
import { TabsetComponent } from "ngx-bootstrap/tabs";
import { BsModalService } from "ngx-bootstrap/modal";
import { NavigationService } from "../../../services/navigation/navigation.service";
/**
 * Class DetailComponent
 */
export class DetailComponent {
    /**
     * Function > constructor
     * @param {ActivatedRoute} activate_route
     * @param {Router} router
     * @param {BsModalService} modal_service
     * @param {TranslateService} translate_service
     * @param {ToastrService} toastr_service
     * @param {DetailService} detail_service
     * @param {DomSanitizer} sanitizer
     * @param {HelperService} helper_service
     * @param {SharedDataService} shared_data_service
     * @param {Ng4LoadingSpinnerService} spinner_service
     * @param form_builder
     * @param navigation_service
     */
    constructor(activate_route, router, modal_service, translate_service, toastr_service, detail_service, sanitizer, helper_service, shared_data_service, spinner_service, form_builder, navigation_service) {
        this.activate_route = activate_route;
        this.router = router;
        this.modal_service = modal_service;
        this.translate_service = translate_service;
        this.toastr_service = toastr_service;
        this.detail_service = detail_service;
        this.sanitizer = sanitizer;
        this.helper_service = helper_service;
        this.shared_data_service = shared_data_service;
        this.spinner_service = spinner_service;
        this.form_builder = form_builder;
        this.navigation_service = navigation_service;
        /**
         * Public Attributes
         */
        this.bs_modal_ref = new Map();
        this.contents_helper = new ContentsHelper(null);
        this.deleted = false;
        this.log = ENVIRONMENT.log;
        this.save_button_deactivated = false;
        // Noetig um ueber properties eines Objekts zu iterieren
        this.objectKeys = Object.keys;
        this.updated_data = {};
        this.development = ENVIRONMENT.env === 'development';
        this.iframe = false;
        /**
         * Private Attributes
         */
        this.modal_options = ENVIRONMENT.modal_options;
        this.subscriptions = [Subscription.EMPTY];
        this.formbuilder_subscriptions = [Subscription.EMPTY];
        this.nested_listing = false;
        this.new_publicationobjects = false;
        // Lade Daten neu, sobald Routernavigation beendet ist (nicht an params festgemacht, da nach speichern reload auf selbe route ausgeloest wird)
        this.subscriptions.push(this.router.events.subscribe(event => {
            // Einhaengen, sobald Navigation erfolgreich beendet ist
            if (event instanceof NavigationEnd) {
                this.initializeData();
            } // end if
        }));
        // Reagiere auf Aenderung der statisch mitgegebenen Data-Werte
        this.subscriptions.push(this.activate_route.data.subscribe(data => {
            this.nested_listing = data["nested_listing"];
        }));
        // Reagiere auf Aenderung der URL-Parameter
        this.subscriptions.push(this.activate_route.params.subscribe(params => {
            this.route_submenu = params["route_submenu"];
            this.listing_id = params["listing_id"];
            if (this.router.url === "/profile/users") {
                this.route_submenu = "users";
            }
        }));
        // Reagiere auf Aenderung der Parent-URL-Parameter
        this.subscriptions.push(this.activate_route.parent.params.subscribe(params => {
            this.route_menu = params["route_menu"];
            if (this.router.url === "/profile/users") {
                this.route_menu = "profile";
            }
        }));
        this.main_form_group = this.form_builder.group({});
    } // end function constructor
    /**
     * Function > initializeData
     */
    initializeData() {
        // Konfiguration (und darin die Daten) der Detailansicht aus Daten des Resolvers holen
        this.detail_config = this.activate_route.snapshot.data.OBJ_detail_config;
        // Detailansicht fuer Neuanlegen? Entweder ueber detail-id, oder ueber per data mitgegebenem Parameter bei nested_listings
        this.new = this.activate_route.snapshot.params.id === "new" || (this.nested_listing && !this.listing_id);
        // bulkinsert?
        this.bulk = this.activate_route.snapshot.queryParamMap.get("bulk") !== null;
        // HTTp-Parameter auslesen und fuer reload speichern
        let query_params = {};
        Object.keys(this.activate_route.snapshot.queryParams).forEach(key => {
            query_params[key] = this.activate_route.snapshot.queryParams[key];
        });
        this.params = { "queryParams": query_params };
        this.new_publicationobjects = this.detail_service.BOO_new_publicationobjects;
        if (this.new_publicationobjects) {
            this.toastr_service.warning(this.translate_service.instant("oDetail.sNewPublicationobjects"), this.translate_service.instant("oDetail.sChanges"), {
                disableTimeOut: true,
                closeButton: true
            });
        } // end if
        // Ist Tabset initialisiert
        if (this.tab_set) {
            // Setze ersten tab auf active, sonst ist nach reload z.T. keiner selektiert
            this.tab_set.tabs[0].active = true;
        } // end if
        // Mark form as unsubmitted again
        this.submitted = false;
    } // end function initializeData
    /**
     * LifecycleHook > ngOnDestroy
     */
    ngOnDestroy() {
        this.detail_service.clearForm();
        // Unsubscribe from all subscriptions to prevent memory leak
        this.subscriptions.forEach((OBJ_subscription) => { OBJ_subscription.unsubscribe(); });
        // Unsubscribe from all subscriptions to prevent memory leak
        this.formbuilder_subscriptions.forEach((OBJ_subscription) => { OBJ_subscription.unsubscribe(); });
    } // end LifecycleHook ngOnDestroy
    findInvalidControls(form_group) {
        const invalid = [];
        const controls = form_group.controls;
        for (const name in controls) {
            if (controls[name] instanceof FormGroup) {
                for (const name2 in controls[name].controls) {
                    if (controls[name].controls[name2].invalid) {
                        invalid.push({ name: name2, control: controls[name].controls[name2] });
                    }
                }
            }
            else if (controls[name].invalid) {
                invalid.push({ name: name, control: controls[name] });
            }
        }
        return invalid;
    }
    /**
     * Function > OBJ_save_event
     * @return {void}
     */
    save() {
        // form is valid
        if (this.main_form_group.valid) {
            this.save_button_deactivated = true;
            // bulkinsert
            if (this.bulk) {
                this.detail_service.bulkInsert(this.detail_config, this.navigation_service.getDataEndpointParamsByRoute(this.route_menu, this.route_submenu)).subscribe((response) => {
                    // Gebe alle Erfolge, Fehler und duplicate Contents an
                    if (response.successful.length > 0) {
                        this.toastr_service.success(this.translate_service.instant("oBulkinsert.sSavedSuccessfully") + " " + response.successful.join(", "), this.translate_service.instant("oBulkinsert.sSavedSuccessfullyTitle"), {
                            disableTimeOut: true,
                            closeButton: true,
                            tapToDismiss: false
                        });
                    }
                    if (response.duplicate.length > 0) {
                        this.toastr_service.warning(this.translate_service.instant("oBulkinsert.sDuplicateContent") + " " + response.duplicate.join(", "), this.translate_service.instant("oBulkinsert.sDuplicateContentTitle"), {
                            disableTimeOut: true,
                            closeButton: true,
                            tapToDismiss: false
                        });
                    }
                    if (response.error.length > 0) {
                        this.toastr_service.error(this.translate_service.instant("oBulkinsert.sError") + " " + response.error.join(", "), this.translate_service.instant("oBulkinsert.sErrorTitle"), {
                            disableTimeOut: true,
                            closeButton: true,
                            tapToDismiss: false
                        });
                    }
                }, (error) => {
                    this.showError(error);
                    // Nach Speichern mit Fehler dennoch weiter Speichern ermoegleichen
                    this.save_button_deactivated = false;
                }, () => {
                    this.markAsNew();
                });
            }
            // new content
            else if (this.new) {
                this.detail_service.create(this.detail_config, this.navigation_service.getDataEndpointParamsByRoute(this.route_menu, this.route_submenu)).subscribe((response) => {
                    // hole ID des neuerstellten Objectes
                    this.detail_service.STR_detailurl = this.contents_helper.getLinkToSelf(response);
                    // Navigiere zu korrekter Detailansicht
                    this.reloadDetail(this.contents_helper.findId(response));
                }, (error) => {
                    this.showError(error);
                    // Nach Speichern mit Fehler dennoch weiter Speichern ermoegleichen
                    this.save_button_deactivated = false;
                }, () => {
                    // output success
                    this.toastr_service.success(this.translate_service.instant("saved_successfully"));
                    this.markAsNew();
                });
            }
            // update content
            else {
                this.detail_service.update(this.detail_config, this.navigation_service.getDataEndpointParamsByRoute(this.route_menu, this.route_submenu)).subscribe(response => {
                    // console log
                    this.helper_service.log({ class: 'DetailComponent', function: 'save' }, "Response after save:", response);
                    if (response !== null) {
                        let route_id = this.contents_helper.findId(response);
                        // Keine Listingansicht vorhanden, lade Standalone-Detailansicht
                        if (this.isStandaloneDetail()) {
                            this.router.navigate([
                                this.route_menu,
                                this.route_submenu,
                                "detail",
                                route_id
                            ]);
                        }
                        else {
                            // Triggere Reload der Detailseite
                            this.reloadDetail(route_id);
                        } // end if
                        // output success
                        this.toastr_service.success(this.translate_service.instant("saved_successfully"));
                        this.markAsNew();
                    } // end if
                }, OBJ_error => {
                    this.helper_service.log({ class: 'DetailComponent', function: 'update' }, "Error", OBJ_error);
                    this.showError(OBJ_error);
                    // Nach Speichern mit Fehler dennoch weiter Speichern ermoegleichen
                    this.save_button_deactivated = false;
                });
            } // end if
        }
        else {
            // mark fields as touched
            this.validateAllFormFields(this.main_form_group);
            // show error
            this.toastr_service.error(this.translate_service.instant("oError.sInvalidFields"));
            // scroll to first error
            this.scrollIfFormHasErrors(this.main_form_group).then(() => {
                // Run any additional functionality if you need to.
            });
        } // end if
    } // end function OBJ_save_event
    /**
     * Function > validateAllFormFields
     * @param {FormGroup} form_group
     * @return void
     */
    validateAllFormFields(form_group) {
        // this.findInvalidControls(form_group);
        let errors = [];
        Object.keys(form_group.controls).forEach(STR_name => {
            let form_control = form_group.get(STR_name);
            if (form_control instanceof FormControl) {
                form_control.markAsTouched({ onlySelf: true });
            }
            else if (form_control instanceof FormGroup) {
                this.validateAllFormFields(form_control);
            } // end if
            const control_errors = form_control.errors;
            if (this.log && control_errors != null) {
                Object.keys(control_errors).forEach(STR_key_error => {
                    errors.push({ control: STR_name, error: STR_key_error, value: form_control.errors[STR_key_error] });
                });
            } // end if
        });
        if (errors.length > 0) {
            // console log
            this.helper_service.log({ class: 'DetailComponent', function: 'validateAllFormFields', errors: errors });
        } // end if
    } // end function validateAllFormFields
    /**
     * Function > scrollIfFormHasErrors
     * @param {FormGroup} form_group
     * @return Promise<any>
     */
    scrollIfFormHasErrors(form_group) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.main_form_group.invalid;
            this.scrollToError();
        });
    } // end function scrollIfFormHasErrors
    /**
     * Function > delete
     * @return {void}
     */
    delete() {
        this.detail_service.delete(this.navigation_service.getDataEndpointParamsByRoute(this.route_menu, this.route_submenu)).subscribe(OBJ_response => {
        }, OBJ_error => {
            this.showError(OBJ_error);
        }, () => {
            // Fuer den Fall dass Navigation fehlschlaegt soll Inhalt dennoch nicht mehr angezeigt werden
            this.deleted = true;
            // Dialog ausblenden
            this.bs_modal_ref.get('delete').hide();
            // Gib Erfolgsmeldung zurueck
            this.toastr_service.success(this.translate_service.instant("deleted_successfully"));
            // Seite verlassen
            this.goBack();
        });
    } // end function delete
    /**
     * Function > showError
     *
     * @desc Gebe Nutzer Feedback ueber Fehler
     * @param error
     */
    showError(error) {
        if (typeof error.error !== "undefined") {
            if (typeof error.error.cst_type != "undefined") {
                // output error
                this.toastr_service.error(this.translate_service.instant(error.error.cst_type.toLowerCase()));
                return;
            }
        } // end if
        // Ansonsten gib Fehler weiter, damit er an Sentry gegeben wird und Nutzer Fehlercode zu sehen bekommt
        throw new Error(JSON.stringify(error));
    } // end function showError
    /**
     * Function > openModal
     * @param {TemplateRef<any>} template_ref
     * @param {string} name
     * @param {string} object_name
     * @return {void}
     */
    openModal(template_ref, name, object_name = null) {
        this.object_name = object_name;
        this.bs_modal_ref.set(name, this.modal_service.show(template_ref, this.modal_options));
    } // end function openModal
    /**
     * Function > hideModal
     * @param {string} type
     * @return {void}
     */
    hideModal(type) {
        this.bs_modal_ref.get(type).hide();
    } // end function hideModal
    /**
     * Function > goBack
     * @desc Take a step back in the navigation
     */
    goBack() {
        this.helper_service.goBack(this.router, this.isStandaloneDetail());
    } // end function goBack
    /**
     * Function > changeIframe
     * @param iframe
     * @param {string} class_name
     */
    changeIframe(iframe, class_name) {
        if (iframe.className == class_name) {
            iframe.className = 'tig-default';
        }
        else {
            iframe.className = class_name;
        }
    } // end function changeIframe
    /**
     * Function > disableTab
     *
     * @param {DetailConfigurationField} field
     * @return {boolean}
     */
    disableTab(field) {
        // Wenn Feld visible nicht gesetzt zeige Tab, ansonsten ist es von visible abhaengig
        return (field.visible == null ? false : !field.visible);
    } // end function disableTab
    isStandaloneDetail() {
        // Navigiere zu Listingansicht
        let url = this.router.url;
        let url_parts = url.split("/");
        // Keine Listingansicht vorhanden, navigiere zu Startseite
        if (url_parts.length >= 4 && url_parts[3] == "detail") {
            return true;
        } // end if
        return false;
    }
    /**
     * Function > debugFunctionUpdateData
     *
     * @desc Internal function to show json which would be sent to the backend
     */
    debugFunctionUpdateData() {
        this.updated_data = this.detail_service.getUpdatedData();
    } // end function debugFunctionUpdateData
    /**
     * Function > unloadNotification
     * @desc Notify the user of unsaved changed before reload
     * @param event
     */
    unloadNotification(event) {
        if (this.hasUnsavedChanges()) {
            event.returnValue = true;
        } // end if
    } // end function unloadNotification
    /**
     * Function > hasUnsavedChanges
     *
     * @desc Forumlar has been edited by the user and has not already been submitted
     */
    hasUnsavedChanges() {
        return this.main_form_group.dirty && !this.submitted;
    } // end function hasUnsavedChanges
    /**
     * Function > scrollTo
     * @param {Element|null} element
     */
    scrollTo(element) {
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        } // end if
    } // end function scrollTo
    /**
     * Function > scrollToError
     */
    scrollToError() {
        const first_element_with_error = document.querySelector('.has-error');
        this.scrollTo(first_element_with_error);
    } // end function scrollToError
    /**
     * Function > showIframe
     */
    showIframe() {
        this.iframe = true;
    } // end function showIframe
    reloadDetail(id) {
        this.detail_service.clearForm();
        // navigate to the appropriate component
        if (this.nested_listing) {
            return this.navigateNestedListing(id, this.params);
        }
        else {
            let route = [
                this.route_menu,
                this.route_submenu
            ];
            // Bei Nutzerdetailansicht keine id mitgeben
            if (this.router.url !== "/profile/users") {
                route.push(id);
            }
            // Auf Profildetailansicht keine ID mitgeben
            this.router.navigate(route, this.params);
        }
    }
    navigateNestedListing(id, query_params) {
        // wenn listing_id schon gesetzt ist befinden wir uns schon in verschachteltem Listing - naechster Stop: Detailansicht
        this.listing_id ? this.router.navigate([
            this.route_menu,
            "listing",
            this.route_submenu,
            this.listing_id,
            id
        ], query_params) : this.router.navigate([
            this.route_menu,
            "listing",
            this.route_submenu,
            id
        ], query_params);
    }
    markAsNew() {
        this.save_button_deactivated = false;
        // mark form as untouched again
        this.submitted = true;
        this.main_form_group.markAsPristine();
        this.main_form_group.markAsUntouched();
    }
    debugFunctionAssignments() {
        this.save_seperately = this.detail_service.getSaveSeperately();
    }
    duplicate() {
        // form is valid
        if (this.main_form_group.valid) {
            let new_config = this.detail_config;
            new_config["fields"].forEach(function (value, key) {
                if (value["name"] == "id") {
                    new_config["fields"][key]["value"] = "0";
                }
                if (value["name"] == "title") {
                    new_config["fields"][key]["value"] += " [DUPLIKAT]";
                }
                if (value["name"] == "status") {
                    new_config["fields"][key]["value"] = 1;
                }
            });
            this.detail_service.create(new_config, this.navigation_service.getDataEndpointParamsByRoute(this.route_menu, this.route_submenu)).subscribe((response) => {
                // hole ID des neuerstellten Objectes
                this.detail_service.STR_detailurl = this.contents_helper.getLinkToSelf(response);
                // Navigiere zu korrekter Detailansicht
                this.reloadDetail(this.contents_helper.findId(response));
            }, (error) => {
                this.showError(error);
                // Nach Speichern mit Fehler dennoch weiter Speichern ermoegleichen
                this.save_button_deactivated = false;
            }, () => {
                // output success
                this.toastr_service.success(this.translate_service.instant("duplicated_successfully"));
                this.markAsNew();
            });
        }
    }
} // end class DetailComponent
